// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-3883b7d3] .el-drawer__header {\n  margin-bottom: 0;\n  font-size: 20px;\n}\n.infoBox[data-v-3883b7d3] .el-icon-arrow-down,\n.infoBox[data-v-3883b7d3]  .el-icon-arrow-up {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
